// ############################################################
/**
 * @todo Document this
 */
// ############################################################

import React from 'react'
import './SwitchElement.css'

// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
/**
 * @todo Document this
 */
const SwitchElementUpdated: React.FC<{
  on: boolean
  onSwitch: () => void
  onText?: string
  offText?: string
  width?: number
}> = ({ on, onSwitch, onText, offText, width }) => {
  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  return (
    <button
      onClick={onSwitch}
      className={
        'relative tw-button-ticketing ' + (on ? 'bg-SeabiscuitGreenThemeColor yes' : 'bg-gray-200 no')
      }
      value={on ? onText || 'Yes' : offText || 'No'}
      style={{ width }}
    >
      <span className="bg-SeabiscuitWhiteThemeColor"></span>
      <div
        className={
          'btn-text text-base  ' +
          (on ? 'yes text-SeabiscuitWhiteThemeColor' : 'no text-[#1F417380]')
        }
      >
        {on ? onText || 'Yes' : offText || 'No'}
      </div>
    </button>
  )
}

export default SwitchElementUpdated
